import { plural } from './format';

const chars = (n: number) => `${n} ${plural(n, 'znak', 'znaki', 'znaków')}`;

/** Podpowiedź pod polem z wymaganą minimalną długością (np. powód storna) — żeby nieaktywny przycisk miał wyjaśnienie. */
export function minHint(value: string, min = 3): string {
  const n = min - value.trim().length;
  if (n <= 0 || !value.trim()) return `Wymagane — co najmniej ${chars(min)}; zapisze się w historii`;
  return `Jeszcze ${chars(n)} (co najmniej ${min})`;
}
